// BaseEntity — common fields for every Mongo-persisted Blueticks doc.
// The `_id` is a string after Mongoose serialization; `tempId` covers
// client-side optimistic rows that haven't been written yet. `version`,
// `dirtySessionId`, `dirty` are sync-engine bookkeeping.

import { z } from 'zod';

export const BaseEntitySchema = z.object({
  _id: z.string().optional(),
  tempId: z.string().optional(),
  version: z.number().optional(),
  dirtySessionId: z.string().optional(),
  dirty: z.boolean().optional(),
});
export type BaseEntity = z.infer<typeof BaseEntitySchema>;
